import repair1 from "assets/images/Repair1.png";
import repair2 from "assets/images/Repair2.png";
import dayjs from "dayjs";
import { humanizeEnum, formatIssueAndSubIssue, formatDate, formatCurrency, resolveEstimatedRange } from "../../utils/utils";

const formatBoolean = (value, yesText = "Yes", noText = "No") =>
  value ? yesText : noText;

const safeText = (value) => (value ? String(value) : "--");


const formatAttachments = (media = []) =>
  (Array.isArray(media) ? media : [])
    .filter(Boolean)
    .map((file, index) => ({
      image:
        file?.file_url ||
        file?.fileUrl ||
        file?.file ||
        file?.url ||
        file?.secureUrl ||
        file?.signedUrl ||
        file?.previewUrl ||
        file?.path ||
        file?.location ||
        "",
      value:
        file?.original_name ||
        file?.originalName ||
        file?.fileName ||
        file?.filename ||
        file?.name ||
        `Attachment ${index + 1}`,
    }))
    .filter((item) => item.image || item.value);

const SLOT_RANGE_LABELS = {
  morning: "Morning (8am - 12pm)",
  afternoon: "Afternoon (12pm - 3pm)",
  evening: "Evening (3pm - 5pm)",
  allDay: "All Day (8am - 5pm)",
};

const formatAvailabilitySlots = (days = []) => {
  if (!Array.isArray(days) || days.length === 0) return "--";
  return days
    .map((entry) => {
      if (!entry || typeof entry !== "string" || !entry.includes("|"))
        return entry;
      const [iso, slot] = entry.split("|");
      const dateLabel = dayjs(iso).isValid() ? dayjs(iso).format("ddd, MMM D") : iso;
      const slotLabel = SLOT_RANGE_LABELS[slot] || slot;
      if (!dateLabel && !slotLabel) return entry;
      if (!dateLabel) return slotLabel;
      if (!slotLabel) return dateLabel;
      return `${dateLabel} — ${slotLabel}`;
    })
    .join(", ");
};

const groupAvailabilitySlots = (days = []) => {
  if (!Array.isArray(days) || days.length === 0) return [];
  const grouped = days.reduce((acc, entry) => {
    if (!entry) return acc;
    if (typeof entry !== "string" || !entry.includes("|")) {
      if (!acc["_others"]) acc["_others"] = [];
      acc["_others"].push({
        label: String(entry),
        value: String(entry),
      });
      return acc;
    }
    const [iso, slot] = entry.split("|");
    if (!acc[iso]) acc[iso] = [];
    acc[iso].push({
      label: SLOT_RANGE_LABELS[slot] || slot,
      value: entry,
    });
    return acc;
  }, {});

  const result = Object.keys(grouped)
    .filter((key) => key !== "_others")
    .sort()
    .map((iso) => ({
      dateLabel: dayjs(iso).isValid() ? dayjs(iso).format("ddd, MMM D") : iso,
      slots: grouped[iso],
    }));

  if (grouped["_others"]) {
    result.push({
      dateLabel: "",
      slots: grouped["_others"],
    });
  }

  return result;
};

const formatDateRange = (from, to) => {
  if (!from || !to) return "--";
  const start = dayjs(from).format("MMM D, YYYY");
  const end = dayjs(to).format("MMM D, YYYY");
  return `${start} → ${end}`;
};

export const formatAddress = (address) => {
  if (!address) return "";
  const humanizeCity = (value) => {
    if (!value) return "";
    return String(value)
      .replace(/_/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };

  const cityPart = humanizeCity(address.city);
  const statePart = (address.state || "").toString().toUpperCase();

  return [
    address.streetAddress || address.street_address,
    address.unitApt || address.unit_apt
      ? `Apt ${address.unitApt || address.unit_apt}`
      : null,
    [cityPart, statePart].filter(Boolean).join(" "),
    address.zipCode || address.zip_code,
    address.country,
  ]
    .filter(Boolean)
    .join(", ");
};

export const MANAGE_JOB = [
  {
    id: 1,
    title: "Job Information",
    items: [
      { label: "Job Title:", value: "Fix leaky bathroom faucet" },
      { label: "Job Category:", value: "Plumbing" },
      {
        label: "Job Description:",
        value:
          "Water is dripping continuously from the bathroom faucet. Tried tightening but it didn't help. May need a replacement. Urgent as it's causing water waste.",
      },
      { label: "Scheduled Time:", value: "Wednesday Morning (8am–12pm)" },
    ],
  },
  {
    id: 2,
    title: "Tenant Information",
    items: [
      {
        label: "Tenant Name:",
        value: "Jason Smith",
      },
      {
        label: "Phone Number:",
        value: "+1 (516)- 123-4576",
      },
      {
        label: "Email:",
        value: "JSmith@gmail.com",
      },
    ],
  },
  {
    id: 3,
    title: "Property Information",
    items: [
      {
        label: "Property Access:",
        value: "Please enter through side door",
      },
      {
        label: "Pet Information:",
        value: "Please enter through side door",
      },
      {
        label: "Property Information:",
        value: "123 Main Street, Apt 4B, New York, NY 10001",
      },
    ],
  },
];

export const JOB_DETAILS = [
  {
    id: 1,
    items: [
      { label: "Job Title:", value: "Fix leaky bathroom faucet" },
      { label: "Location", value: "Huntington, NY" },
      {
        label: "Job Description:",
        value:
          "Water is dripping continuously from the bathroom faucet. Tried tightening but it didn't help. May need a replacement. Urgent as it's causing water waste.",
      },
      { label: "Scheduled Time", value: "Wednesday Morning (8am–12pm)" },
    ],
  },
  {
    id: 2,
    title: "Property Information",
    items: [
      {
        label: "Property Access:",
        value: "Please enter through side door",
      },
      {
        label: "Property Information:",
        value: "Please enter through side door",
      },
      {
        label: "Property Address:",
        value: "123 Main Street, Apt 4B, New York, NY 10001",
      },
      {
        label: "Map Preview:",
        value:
          "https://www.google.com/maps?q=123%20Main%20Street%2C%20Apt%204B%2C%20New%20York%2C%20NY%2010001&output=embed",
      },
    ],
  },
];
export const MODAL_STATES = {
  MANAGE_JOB: "manageJob",
  CANCEL_JOB: "cancelJob",
  CANCEL_CONFIRM: "cancelConfirm",
  CANCELED_CONFIRMATION: "canceledConfirmation",
  JOB_DETAILS: "jobDetails",
  JOB_CONFIRMED: "jobConfirmed",
  MODIFY_JOB: "modifyJob",
  RESCHEDULE_JOB: "rescheduleJob",
  COMPLETE_JOB: "completeJob",
  JOB_SUMMARY: "jobSummary",
};

export function generateManageJob(response) {
  // Check if tenant information exists
  const hasTenantInfo = response?.tenantInfo || response?.tenant_info;

  console.log("Response in generateManageJob:", response);

  const initialRange = resolveEstimatedRange(response) || "N/A";

  // Find the latest estimate (initial bid or latest change proposal)
  const acceptedList =
    response?.acceptedChangeProposals || response?.accepted_change_proposals || [];
  const pendingList =
    response?.pendingChangeProposals || response?.pending_change_proposals || [];

  let latestEstimate = null;
  let isPending = false;

  const allProposals = [...pendingList, ...acceptedList];
  if (allProposals.length > 0) {
    const latest = allProposals.reduce((acc, cur) => (Number(cur.id) > Number(acc.id) ? cur : acc));
    latestEstimate = latest.newEstimate || latest.new_estimate;
    isPending = pendingList.some((p) => Number(p.id) === Number(latest.id));
  }

  const jobInfoItems = [
    {
      label: "Job Category:",
      value:
        formatIssueAndSubIssue(
          response?.issueType || response?.issue_type,
          response?.subIssueType || response?.sub_issue_type
        ) || "N/A",
    },
    {
      label: "Job Description:",
      value: response?.description || "No description provided",
    },
    {
      label:
        response?.status == "IN_PROGRESS" ? "Scheduled Time:" : "Availability:",
      value: (() => {
        const status = String(response?.status || "").toUpperCase();
        const sDate = response?.scheduledDate || response?.scheduled_date;
        const sTime = response?.scheduledTime || response?.scheduled_time;
        if (status === "IN_PROGRESS" && sTime) {
          // If we have explicit scheduled fields, use them (returns grouped structure for Details.jsx)
          // Fallback to just sTime if sDate is not provided or parsed
          return groupAvailabilitySlots(sDate ? [`${sDate}|${sTime}`] : [sTime]);
        }
        return groupAvailabilitySlots(
          response?.daysAvailable || response?.days_available || []
        );
      })(),
    },
    {
      label: "Original Job Estimate Range:",
      value: initialRange,
    },
  ];

  // Only show the vendor's estimate if it was actually "edited" (different from original range)
  if (latestEstimate && String(latestEstimate).trim() !== String(initialRange).trim()) {
    jobInfoItems.push({
      label: "Vendor's Submitted Estimate:",
      value: `${formatCurrency(latestEstimate)}${isPending ? " (Pending Approval)" : ""}`,
    });
  }

  const sections = [
    {
      id: 1,
      title: "Job Information",
      items: jobInfoItems,
    },
  ];

  // Only add tenant information section if tenant data exists
  if (hasTenantInfo) {
    sections.push({
      id: 2,
      title: "Tenant Information",
      items: [
        {
          label: "Tenant Name:",
          value:
            response?.tenantInfo?.fullName ||
            response?.tenant_info?.full_name ||
            "--",
        },
        // {
        //   label: "Phone Number:",
        //   value:
        //     response?.tenantInfo?.phoneNumber ||
        //     response?.tenant_info?.phone_number ||
        //     "--",
        // },
        {
          label: "Email:",
          value:
            response?.tenantInfo?.email || response?.tenant_info?.email || "--",
        },
      ],
    });
  }

  // Add property information section
  sections.push({
    id: hasTenantInfo ? 3 : 2,
    title: "Property Information",
    items: [
      {
        label: "Property Address:",
        value:
          response?.propertyAddress || response?.property_address
            ? formatAddress(
                response?.property_address || response?.propertyAddress
              )
            : "N/A",
      },
      {
        label: "Technician Can Enter Without Presence:",
        value: formatBoolean(
          response?.can_enter_without_presence ??
            response?.canEnterWithoutPresence
        ),
      },
      {
        label: "Property Access Instructions:",
        value:
          response?.accessInstructions ||
          response?.access_instructions ||
          response?.can_enter_details ||
          response?.canEnterDetails ||
          "No special instructions",
      },
      {
        label: "Pet Information:",
        value: response?.hasPets || response?.has_pets
          ? response?.petDetails || response?.pet_details || "Pets on site"
          : "No pets on site",
      },
      {
        label: "Additional Details:",
        value:
          response?.access_details ||
          response?.accessDetails ||
          response?.additionalDetails ||
          response?.has_access_info ||
          response?.hasAccessInfo
            ? response?.access_details ||
              response?.accessDetails ||
              response?.additionalDetails ||
              "--"
            : "--",
      },
    ],
  });

  const attachmentItems = formatAttachments(response?.media || []);
  if (attachmentItems.length) {
    sections.push({
      id: sections.length + 1,
      title: "Attachments",
      items: [
        {
          label: "Attachments:",
          value: attachmentItems,
        },
      ],
    });
  }

  // If accepted change proposals exist, show only the one with the highest id
  if (Array.isArray(acceptedList) && acceptedList.length) {
    const highest = acceptedList.reduce((acc, cur) => {
      const a = Number(acc?.id || 0);
      const b = Number(cur?.id || 0);
      return b > a ? cur : acc;
    }, acceptedList[0]);

    const additionalWork = highest?.additionalWork || highest?.additional_work || "--";
    const newEstimateRaw = highest?.newEstimate || highest?.new_estimate || "";

    // Normalize media to array and map to attachments
    const mediaNormalized = Array.isArray(highest?.media)
      ? highest.media
      : highest?.media
      ? [highest.media]
      : [];
    const acceptedAttachments = formatAttachments(mediaNormalized);

    const proposalItems = [
      { label: "Additional Work:", value: additionalWork },
    ];
    if (newEstimateRaw !== undefined && newEstimateRaw !== null && String(newEstimateRaw) !== "") {
      proposalItems.push({
        label: "New Estimate:",
        value: formatCurrency(newEstimateRaw),
      });
    }
    if (acceptedAttachments.length) {
      proposalItems.push({ label: "Attachments:", value: acceptedAttachments });
    }

    // Ensure Accepted Change Proposal appears above Attachments (if attachments exist)
    const acceptedSection = {
      id: sections.length + 1,
      title: "Accepted Change Proposal",
      items: proposalItems,
    };
    const attachmentsIndex = sections.findIndex((s) => s.title === "Attachments");
    if (attachmentsIndex !== -1) {
      sections.splice(attachmentsIndex, 0, acceptedSection);
    } else {
      sections.push(acceptedSection);
    }
  }

  // If pending change proposals exist, show only the one with the highest id
  if (Array.isArray(pendingList) && pendingList.length) {
    const highest = pendingList.reduce((acc, cur) => {
      const a = Number(acc?.id || 0);
      const b = Number(cur?.id || 0);
      return b > a ? cur : acc;
    }, pendingList[0]);

    const additionalWork = highest?.additionalWork || highest?.additional_work || "--";
    const newEstimateRaw = highest?.newEstimate || highest?.new_estimate || "";

    const mediaNormalized = Array.isArray(highest?.media)
      ? highest.media
      : highest?.media
      ? [highest.media]
      : [];
    const pendingAttachments = formatAttachments(mediaNormalized);

    const proposalItems = [
      { label: "Additional Work:", value: additionalWork },
    ];
    if (newEstimateRaw !== undefined && newEstimateRaw !== null && String(newEstimateRaw) !== "") {
      proposalItems.push({
        label: "New Estimate:",
        value: formatCurrency(newEstimateRaw),
      });
    }
    if (pendingAttachments.length) {
      proposalItems.push({ label: "Attachments:", value: pendingAttachments });
    }

    const pendingSection = {
      id: sections.length + 1,
      title: "Pending Change Proposal",
      items: proposalItems,
    };
    
    // Insert after Accepted Change Proposal or just before Attachments
    const acceptedIdx = sections.findIndex(s => s.title === "Accepted Change Proposal");
    if (acceptedIdx !== -1) {
      sections.splice(acceptedIdx + 1, 0, pendingSection);
    } else {
      const attachmentsIdx = sections.findIndex(s => s.title === "Attachments");
      if (attachmentsIdx !== -1) {
        sections.splice(attachmentsIdx, 0, pendingSection);
      } else {
        sections.push(pendingSection);
      }
    }
  }

  return sections;
}
export function jobSummary(response) {
  const total = response?.total_billed ?? response?.totalBilled ?? 0;
  const stripeFee = response?.stripe_fee_amount ?? response?.stripeFeeAmount;
  const tax = response?.tax_amount ?? response?.taxAmount;
  const subtotal = response?.subtotal;

  const items = [
    {
      label: "Total billing amount:",
      value: formatCurrency(total),
    },
  ];

  if (stripeFee || tax) {
    if (subtotal) {
      items.push({
        label: "Subtotal:",
        value: formatCurrency(subtotal),
      });
    }
    if (stripeFee) {
      items.push({
        label: "Processing Fee:",
        value: formatCurrency(stripeFee),
      });
    }
    if (tax) {
      items.push({
        label: "Tax:",
        value: formatCurrency(tax),
      });
    }
  }

  items.push(
    {
      label: "Job Category:",
      value:
        formatIssueAndSubIssue(
          response?.issueType || response?.issue_type,
          response?.subIssueType || response?.sub_issue_type
        ) || "N/A",
    },
    {
      label: "Job Description:",
      value: response?.description || "No description provided",
    },
    {
      label: "Date Completed:",
      value: (() => {
        const completedRaw =
          response?.dateOfCompletion ||
          response?.date_of_completion ||
          response?.date_completed ||
          response?.dateCompleted;
        return completedRaw ? formatDate(completedRaw) : "N/A";
      })(),
    }
  );

  return [
    {
      id: 1,
      title: "Job Information",
      items,
    },
  ];
}

export function generatePendingApprovedJob(response) {
  // For consistency, reuse the same section generator as the Jobs modal
  // so both modals display identical information and structure.
  return generateManageJob(response || {});
}

export function generateAvailabeJob(response) {
  if (!response) return [];

  // Resolve availability value similar to Manage Job, but support simple day lists
  const rawDays = response?.daysAvailable || response?.days_available || [];
  let availabilityValue = "--";
  if (Array.isArray(rawDays) && rawDays.length) {
    if (rawDays.some((d) => typeof d === "string" && d.includes("|"))) {
      availabilityValue = groupAvailabilitySlots(rawDays);
    } else {
      availabilityValue = rawDays
        .map((d) => (typeof d === "string" ? capitalizeFirst(d) : String(d)))
        .join(", ");
    }
  }

  const sections = [
    {
      id: 1,
      title: "Job Information",
      items: [
        {
          label: "Job Category:",
          value:
            humanizeEnum(response?.issueType || response?.issue_type) ||
            "N/A",
        },
        {
          label: "Job Type:",
          value:
            humanizeEnum(response?.subIssueType || response?.sub_issue_type) ||
            "--",
        },
        {
          label: "Job Description:",
          value: response?.description || "No description provided",
        },
        {
          label: "Availability:",
          value: availabilityValue,
        },
      ],
    },
    {
      id: 2,
      title: "Property Information",
      items: [
        {
          label: "Property Address:",
          value:
            response?.propertyAddress || response?.property_address
              ? formatAddress(
                  response?.property_address || response?.propertyAddress
                )
              : "N/A",
        },
      ],
    },
  ];

  // Add Budget & Preferences section
  const budgetPreferenceOptions = (() => {
    if (!Array.isArray(rawDays) || rawDays.length === 0) return [];
    // If days are in ISO|slot form, expand to date — slot options
    if (rawDays.some((d) => typeof d === "string" && d.includes("|"))) {
      return groupAvailabilitySlots(rawDays).flatMap(({ dateLabel, slots }) =>
        (slots || []).map((slot) => ({
          label: dateLabel ? `${dateLabel} — ${slot.label || slot}` : (slot.label || slot),
          value: slot.value || slot,
        }))
      );
    }
    // Otherwise, simple list of day names
    return rawDays.map((day) => {
      const lbl = typeof day === "string" ? capitalizeFirst(day) : String(day);
      return { label: lbl, value: lbl };
    });
  })();

  sections.push({
    id: sections.length + 1,
    title: "Budget & Preferences",
    type: "budgetPreferences",
    items: [
      {
        label: "Original Job Estimate Range:",
        value: resolveEstimatedRange(response) || "--",
      },
      {
        label: "Job Post Date:",
        value:
          response?.created_at || response?.createdAt
            ? new Date(
                response.created_at || response.createdAt
              ).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })
            : "--",
      },
      {
        label: "Select a Time to Complete the Work:",
        value: {
          checkbox: true,
          options: budgetPreferenceOptions,
        },
      },
    ],
  });

  const attachmentItems = formatAttachments(response?.media || []);
  if (attachmentItems.length) {
    sections.push({
      id: sections.length + 1,
      title: "Attachments",
      items: [
        {
          label: "Attachments:",
          value: attachmentItems,
        },
      ],
    });
  }

  return sections;
}

export function generateConfirmedJobDetails(response) {
  console.log("generate ConfirmedJobDetails response:", response);

  if (response)
    return [
      {
        id: 1,
        items: [
          {
            label: "Job Title:",
            value:
              response?.issueType || response?.issue_type
                ? formatIssueAndSubIssue(
                    response?.issueType || response?.issue_type,
                    response?.subIssueType || response?.sub_issue_type
                  )
                : "N/A",
          },
          {
            label: "Location",
            value: response?.property_address || response?.propertyAddress
              ? formatAddress(
                  response?.property_address || response?.propertyAddress
                )
              : "N/A",
          },
          {
            label: "Job Description:",
            value: response?.description || "No description provided",
          },
          {
            label: "Price Estimate:",
            value: resolveEstimatedRange(response) || "N/A",
          },
          {
            label: "Scheduled Time:",
            value: formatAvailabilitySlots(
              response.timeSelected ? [response.timeSelected] : []
            ),
          },
        ],
      },
      {
        id: 2,
        title: "Property Information",
        items: [
          {
            label: "Property Access:",
            value: (() => {
              const access =
                response?.accessInstructions || response?.access_instructions;
              const str = (access || "").toString().trim();
              return str !== "" ? str : "No special instructions";
            })(),
          },
          {
            label: "Property Information:",
            value: (() => {
              const access =
                response?.accessInstructions || response?.access_instructions;
              const str = (access || "").toString().trim();
              return str !== "" ? str : "No special instructions";
            })(),
          },
          {
            label: "Map Preview:",
            value: (() => {
              const addr = response?.property_address || response?.propertyAddress;
              if (!addr) return "N/A";
              // Prefer full formatted address over just city/state for accurate map pin
              const fullAddress = typeof addr === "string" ? addr : formatAddress(addr);
              const cleaned = (fullAddress || "").toString().trim();
              if (!cleaned) return "N/A";
              // Use simple query-based embed so Google locates the precise address
              return `https://www.google.com/maps?q=${encodeURIComponent(cleaned)}&output=embed`;
            })(),
          },
        ],
      },
    ];
}
export function generateViewRecentSubmittedRequestDetails(response) {
  console.log("generate ConfirmedJobDetails response:", response);

  if (response)
    return [
      {
        id: 1,
        items: [
          {
            label: "Job Title:",
            value:
              response?.issueType || response?.issue_type
                ? formatIssueAndSubIssue(
                    response?.issueType || response?.issue_type,
                    response?.subIssueType || response?.sub_issue_type
                  )
                : "N/A",
          },

          {
            label: "Job Description:",
            value: response?.description || "No description provided",
          },
          {
            label: "Price Estimate:",
            value: resolveEstimatedRange(response) || "N/A",
          },
          {
            label: "Availability:",
            value: groupAvailabilitySlots(
              response?.daysAvailable || response?.days_available || []
            ),
          },
        ],
      },
      {
        id: 2,
        title: "Property Information",
        items: [
          {
            label: "Property Access:",
            value:
              response?.accessInstructions || response?.access_instructions
                ? response.accessInstructions || response?.access_instructions
                : "No special instructions",
          },

          {
            label: "Property Address:",
            value:
              response?.propertyAddress || response?.property_address
                ? formatAddress(
                    response?.propertyAddress || response?.property_address
                  )
                : "N/A",
          },
        ],
      },
    ];
}

export function generateCompletedJobDetails(response) {
  if (response) {
    const total = response?.total_billed ?? response?.totalBilled;
    const stripeFee = response?.stripe_fee_amount ?? response?.stripeFeeAmount;
    const tax = response?.tax_amount ?? response?.taxAmount;
    const subtotal = response?.subtotal;

    const items = [
      {
        label: "Total billing amount:",
        value: total
          ? formatCurrency(total)
          : "$TBD",
      },
    ];

    if (stripeFee || tax) {
      if (subtotal) {
        items.push({ label: "Subtotal:", value: formatCurrency(subtotal) });
      }
      if (stripeFee) {
        items.push({
          label: "Processing Fee:",
          value: formatCurrency(stripeFee),
        });
      }
      if (tax) {
        items.push({ label: "Tax:", value: formatCurrency(tax) });
      }
    }

    items.push(
      {
        label: "Job Category:",
        value:
          humanizeEnum(response?.issueType || response?.issue_type) || "N/A",
      },
      {
        label: "Job Description:",
        value: response?.description || "No description provided",
      },
      {
        label: "Date Completed:",
        value: response?.updatedAt ? formatDate(response.updatedAt) : "N/A",
      }
    );

    return [
      {
        id: 2,
        title: "Job Information",
        items: items,
      },
    ];
  }
}

export function generateJobDetails(response) {
  console.log("generate JobDetails response:", response);

  if (response) {
    const initialRange = resolveEstimatedRange(response) || "N/A";

    // Find the latest estimate (initial bid or latest change proposal)
    const acceptedList =
      response?.acceptedChangeProposals || response?.accepted_change_proposals || [];
    const pendingList =
      response?.pendingChangeProposals || response?.pending_change_proposals || [];

    let latestEstimate = null;
    let isPending = false;

    const allProposals = [...pendingList, ...acceptedList];
    if (allProposals.length > 0) {
      const latest = allProposals.reduce((acc, cur) => (Number(cur.id) > Number(acc.id) ? cur : acc));
      latestEstimate = latest.newEstimate || latest.new_estimate;
      isPending = pendingList.some((p) => Number(p.id) === Number(latest.id));
    }

    const jobInfoItems = [
      {
        label: "Job Title:",
        value:
          response?.issueType || response?.issue_type
            ? formatIssueAndSubIssue(
                response?.issueType || response?.issue_type,
                response?.subIssueType || response?.sub_issue_type
              )
            : "N/A",
      },
      {
        label: "Location",
        value: response?.propertyAddress
          ? formatAddress(response.propertyAddress)
          : "N/A",
      },
      {
        label: "Job Description:",
        value: response?.description || "No description provided",
      },
      {
        label: "Original Job Estimate Range:",
        value: initialRange,
      },
    ];

    // Only show the vendor's estimate if it was actually "edited" (different from original range)
    if (latestEstimate && String(latestEstimate).trim() !== String(initialRange).trim()) {
      jobInfoItems.push({
        label: "Vendor's Submitted Estimate:",
        value: `${formatCurrency(latestEstimate)}${isPending ? " (Pending Approval)" : ""}`,
      });
    }

    jobInfoItems.push({
      label:
        response?.status == "IN_PROGRESS" ? "Scheduled Time:" : "Availability:",
      value: (() => {
        // Prefer scheduledDate/scheduledTime when job is in progress
        const status = String(response?.status || "").toUpperCase();
        const sDate = response?.scheduledDate || response?.scheduled_date;
        const sTime = response?.scheduledTime || response?.scheduled_time;
        if (status === "IN_PROGRESS" && sTime) {
          const dateLabel = sDate ? (dayjs(sDate).isValid()
            ? dayjs(sDate).format("ddd, MMM D")
            : sDate) : null;
          const slotLabel =
            SLOT_RANGE_LABELS[sTime] ||
            SLOT_RANGE_LABELS[String(sTime).toLowerCase()] ||
            sTime;
          return dateLabel ? `${dateLabel} — ${slotLabel}` : slotLabel;
        }
        // Fallback to available day slots formatting
        return formatAvailabilitySlots(
          response?.daysAvailable || response?.days_available || []
        );
      })(),
    });

    // Build base sections (keep Property Information including Map Preview intact)
    const sections = [
      {
        id: 1,
        items: jobInfoItems,
      },
      {
        id: 2,
        title: "Property Information",
        items: [
          {
            label: "Property Access:",
            value:
              response?.accessInstructions?.trim() !== ""
                ? response.accessInstructions
                : "No special instructions",
          },
          {
            label: "Property Information:",
            value:
              response?.accessInstructions?.trim() !== ""
                ? response.accessInstructions
                : "No special instructions",
          },
          {
            label: "Map Preview:",
            value: (() => {
              const addr =
                response?.property_address || response?.propertyAddress;
              if (!addr) return "N/A";
              const fullAddress =
                typeof addr === "string" ? addr : formatAddress(addr);
              const cleaned = (fullAddress || "").toString().trim();
              if (!cleaned) return "N/A";
              return `https://www.google.com/maps?q=${encodeURIComponent(
                cleaned
              )}&output=embed`;
            })(),
          },
        ],
      },
    ];

    // Insert Accepted Change Proposal section just before Property Information
    if (Array.isArray(acceptedList) && acceptedList.length) {
      const highest = acceptedList.reduce((acc, cur) => {
        const a = Number(acc?.id || 0);
        const b = Number(cur?.id || 0);
        return b > a ? cur : acc;
      }, acceptedList[0]);

      const additionalWork =
        highest?.additionalWork || highest?.additional_work || "--";
      const newEstimateRaw = highest?.newEstimate || highest?.new_estimate || "";

      const mediaNormalized = Array.isArray(highest?.media)
        ? highest.media
        : highest?.media
        ? [highest.media]
        : [];
      const attachments = formatAttachments(mediaNormalized);

      const proposalItems = [{ label: "Additional Work:", value: additionalWork }];
      if (newEstimateRaw !== undefined && newEstimateRaw !== null && String(newEstimateRaw) !== "") {
        proposalItems.push({
          label: "New Estimate:",
          value: formatCurrency(newEstimateRaw),
        });
      }
      if (attachments.length) {
        proposalItems.push({ label: "Attachments:", value: attachments });
      }

      const acceptedSection = {
        id: sections.length + 1,
        title: "Accepted Change Proposal",
        items: proposalItems,
      };

      // Place it at index 1 so it appears above Map Preview (within Property Information)
      sections.splice(1, 0, acceptedSection);
    }

    // Insert Pending Change Proposal section
    if (Array.isArray(pendingList) && pendingList.length) {
      const highest = pendingList.reduce((acc, cur) => {
        const a = Number(acc?.id || 0);
        const b = Number(cur?.id || 0);
        return b > a ? cur : acc;
      }, pendingList[0]);

      const additionalWork =
        highest?.additionalWork || highest?.additional_work || "--";
      const newEstimateRaw = highest?.newEstimate || highest?.new_estimate || "";

      const mediaNormalized = Array.isArray(highest?.media)
        ? highest.media
        : highest?.media
        ? [highest.media]
        : [];
      const pendingAttachments = formatAttachments(mediaNormalized);

      const proposalItems = [{ label: "Additional Work:", value: additionalWork }];
      if (newEstimateRaw !== undefined && newEstimateRaw !== null && String(newEstimateRaw) !== "") {
        proposalItems.push({
          label: "New Estimate:",
          value: formatCurrency(newEstimateRaw),
        });
      }
      if (pendingAttachments.length) {
        proposalItems.push({ label: "Attachments:", value: pendingAttachments });
      }

      const pendingSection = {
        id: sections.length + 1,
        title: "Pending Change Proposal",
        items: proposalItems,
      };

      // Place it after Accepted Change Proposal or at index 1
      const acceptedIdx = sections.findIndex(s => s.title === "Accepted Change Proposal");
      if (acceptedIdx !== -1) {
        sections.splice(acceptedIdx + 1, 0, pendingSection);
      } else {
        sections.splice(1, 0, pendingSection);
      }
    }

    return sections;
  }
}

export function generateJobReviewDetails(response, formValues) {
  const totalAmount = (() => {
    const labor = Number(formValues?.labor_cost) || 0;
    const material = Number(formValues?.material_cost) || 0;
    const flatRate = Number(formValues?.job_cost) || 0;

    const lineItemsTotal = Array.isArray(formValues?.line_items)
      ? formValues.line_items.reduce(
          (sum, item) => sum + (Number(item.amount) || 0),
          0
        )
      : 0;

    const hasLaborOrMaterial = labor > 0 || material > 0;

    const baseAmount = hasLaborOrMaterial ? labor + material : flatRate;

    return baseAmount + lineItemsTotal;
  })();

  console.log("responsess", response, formValues);
  if (response && formValues)
    return [
      {
        id: 2,
        title: "Job Information",
        items: [
          {
            label: "Total billing amount:",
            value: '$' + totalAmount,

            // value: "$TBD", // Placeholder since input doesn't provide billing amount
          },
          {
            label: "Job Category:",
            value:
              humanizeEnum(response?.issueType || response?.issue_type) ||
              "N/A",
          },
          {
            label: "Job Description:",
            value: response?.description || "No description provided",
          },
          // {
          //   label: "Date Completed:",
          //   value: response?.updatedAt
          //     ? new Date(response?.updatedAt).toLocaleDateString("en-US", {
          //         month: "long",
          //         day: "ordinal",
          //         year: "numeric",
          //       })
          //     : "N/A",
          // },
        ],
      },
    ];
}
// helper
function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function generatePostJobSummary(values = {}, lookup = {}) {
  const {
    request_type,
    name,
    email,
    phone_number,
    property,
    unit,
    issue_type,
    sub_issue_type,
    description,
    price_estimate,
    available_from,
    available_to,
    days_available,
    can_enter_without_presence,
    can_enter_details,
    has_pets,
    pet_details,
    access_instructions,
    has_access_info,
    access_details,
    media_files,
  } = values;

  const propertyLabel = lookup.propertyLabel || property || "--";
  const unitLabel = lookup.unitLabel || unit || "--";

  return [
    {
      id: 1,
      title: "Step 1 – Job Type",
      items: [
        {
          label: "Request Type:",
          value:
            request_type === "recurring_task"
              ? "Recurring Task"
              : "One-time Request",
        },
      ],
    },
    {
      id: 2,
      title: "Step 2 – Contact Info",
      items: [
        { label: "Name:", value: safeText(name) },
        { label: "Email:", value: safeText(email) },
        { label: "Phone:", value: safeText(phone_number) },
      ],
    },
    {
      id: 3,
      title: "Step 3 – Property",
      items: [
        { label: "Property:", value: safeText(propertyLabel) },
        { label: "Unit:", value: safeText(unitLabel) },
      ],
    },
    {
      id: 4,
      title: "Step 4 – Issue",
      items: [
        {
          label: "Category:",
          value: formatIssueAndSubIssue(issue_type, sub_issue_type) || "--",
        },
        { label: "Description:", value: safeText(description) },
        { label: "Price Estimate:", value: safeText(price_estimate) },
        {
          label: "Attachment:",
          value: media_files?.name || (media_files ? "Uploaded" : "--"),
        },
      ],
    },
    {
      id: 5,
      title: "Step 5 – Availability",
      items: [
        {
          label: "Date Range:",
          value: formatDateRange(available_from, available_to),
        },
        {
          label: "Slots:",
          value: formatAvailabilitySlots(days_available),
        },
      ],
    },
    {
      id: 6,
      title: "Step 6 – Property Access",
      items: [
        {
          label: "Can Enter Without Presence:",
          value: formatBoolean(can_enter_without_presence),
        },
        {
          label: "Entry Instructions:",
          value: safeText(can_enter_details),
        },
      ],
    },
    {
      id: 7,
      title: "Step 7 – Pets",
      items: [
        { label: "Pets On Site:", value: formatBoolean(has_pets) },
        { label: "Pet Details:", value: safeText(pet_details) },
      ],
    },
    {
      id: 8,
      title: "Step 8 – Additional Access",
      items: [
        {
          label: "Additional Access Info:",
          value: formatBoolean(has_access_info),
        },
        {
          label: "Access Details:",
          value: safeText(access_details || access_instructions),
        },
      ],
    },
  ];
};
